import { makeStyles } from "@mui/styles";
import { COLOR_CONSTANTS } from "../../../../constants/StyleConstants";

const LoginCallbackPageStyles = makeStyles((theme) => ({
  formContainer: {
    position: "relative",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 10px 0px #00000024",
    padding: "38px",
    borderRadius: "10px",
    "& h5": {
      marginBottom: "20px"
    }
  },
  center: {
    textAlign: "center",
    margin: "25px auto",
    "& button": {
      marginRight: 0
    }
  },
  input: {
    "& .requiredFlag": {
      top: "-5px",
      left: "10px",
      paddingLeft: "0"
    },
    "& #accessCode-label.MuiInputLabel-shrink": {
      textAlign: "left",
      paddingLeft: "5px"
    }
  },
  link: {
    textDecoration: "underline",
    cursor: "pointer",
    display: "inline"
  },
  lightSubheader: {
    color: COLOR_CONSTANTS.GENOMIC_LIFE_GREEN
  },
  continueButton: {
    borderRadius: 0,
    marginTop: "10px",
    marginLeft: "0",
    marginBottom: "30px",
    width: "100%"
  }
}));

export default LoginCallbackPageStyles;
